import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  container: { backgroundColor: theme.COLOR_BG_BASE, flex: 1 },
  headerTitle: { alignItems: 'center', gap: rh(4) },
  headerText: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(18), lineHeight: rh(22) },
  headerIcon: { borderRadius: rw(12), height: rw(24), width: rw(24) },
  rate: { color: theme.COLOR_TEXT_SECONDARY, fontSize: rf(16), lineHeight: rh(22) },
  amountBlock: { alignItems: 'center', flex: 1, gap: rh(16), justifyContent: 'center' },
  amount: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(48),
    letterSpacing: rw(-1.44),
    lineHeight: rh(53),
  },
  converted: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(16), lineHeight: rh(20) },
  swapButton: { alignItems: 'center', justifyContent: 'center', minHeight: rh(24), minWidth: rw(24) },
  balanceChip: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(999),
    marginBottom: rh(16),
    paddingHorizontal: rw(16),
    paddingVertical: rh(16),
  },
  balanceError: { color: theme.COLOR_TEXT_CRITICAL, fontSize: rf(16), lineHeight: rh(22.4), textAlign: 'center' },
  balanceErrorText: { color: theme.COLOR_TEXT_CRITICAL },
  balanceText: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(16), lineHeight: rh(20) },
  cta: { paddingHorizontal: rw(24), paddingBottom: rh(16), paddingTop: rh(16), width: '100%' },
}))
